import "../index";

import { getAuth, onAuthStateChanged, signOut, sendPasswordResetEmail } from "firebase/auth";
import { doc, getDoc, getFirestore, setDoc, getDocFromCache, writeBatch, enableIndexedDbPersistence, arrayUnion } from "firebase/firestore";
import { Collapse } from "bootstrap";
import raterFunction from "rater-js";
import { marked } from "marked";
import xss from "xss";

const auth = getAuth();
const db = getFirestore();

var judgeUID;
var judgeData;
var assignedTeamUID;
var assignedTeamDataList = [];
var currentEvalData;
var currentTeamNo;
var currentTeamUID;
var currInterval;

document.addEventListener("DOMContentLoaded", () => {
    setSpinner("avatar");

    enableIndexedDbPersistence(db);

    const showNavbar = (toggleId, navId, bodyId, headerId) => {
        const toggle = document.getElementById(toggleId),
            nav = document.getElementById(navId),
            bodypd = document.getElementById(bodyId),
            headerpd = document.getElementById(headerId)

        // Validate that all variables exist
        if (toggle && nav && bodypd && headerpd) {
            toggle.addEventListener('click', () => {
                // show navbar
                nav.classList.toggle('showSB')
                // change icon
                toggle.classList.toggle('bx-x')
                // add padding to body
                bodypd.classList.toggle('body-pd')
                // add padding to header
                headerpd.classList.toggle('body-pd')
            })
        }
    }

    showNavbar('header-toggle', 'nav-bar', 'body-pd', 'header')

    /*===== LINK ACTIVE =====*/
    const linkColor = document.querySelectorAll('.nav_link')

    function colorLink() {
        if (linkColor) {
            linkColor.forEach(l => l.classList.remove('active'))
            this.classList.add('active')
        }
    }
    linkColor.forEach(l => l.addEventListener('click', colorLink))

    // Header hide scroll
    var prevScrollpos = window.pageYOffset;
    window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            document.getElementById("header").style.top = "0";
        } else if (currentScrollPos > 50) {
            document.getElementById("header").style.top = "-64px";
        }
        prevScrollpos = currentScrollPos;
    }

    document.getElementById("previewModalBtn").addEventListener("click", () => {
        document.getElementById("preview-body").innerHTML = xss(marked.parse(
            document.getElementById("judge-cmt").value
        ));
    });

    document.querySelectorAll("textarea").forEach(ele => {
        let counterEle = document.getElementById(ele.id+"-counter");
        if (counterEle) {
            let limitChar = ele.maxLength;
            updateCounter(counterEle, limitChar, ele.value.length);
            
            ele.addEventListener("keydown", () => {
                updateCounter(counterEle, limitChar, ele.value.length);
            }, false);
            
            ele.addEventListener("keyup", () => {
                updateCounter(counterEle, limitChar, ele.value.length);
            }, false);
        }
    });

    function updateCounter(counterEle, limit, currLength) {
        counterEle.innerHTML = limit - currLength;
    }

    // Cut-off time
    // 2/4/2022 2100 GMT+8
    const cutoffTime = 1648630800000;
    const cutoffNotice = document.getElementById("notice-submit");

    // const cutoffTime = 1647660268000; // Demo

    fetch("https://data.vhackusm.com/judge-cutoff.json", {cache: "no-store"})
        .then(res => res.json())
        .then(data => {
            if (data.cutoff !== "-") {
                cutoffNotice.classList.remove("alert-warning");
                cutoffNotice.classList.add("alert-secondary");
        
                cutoffNotice.innerHTML = data.cutoff;
        
                document.getElementById("save-btn").disabled = true;
                document.getElementById("submit-btn").disabled = true;
            }
        });

    // Project details collapse
    var myCollapse = document.getElementById('card-eval');
    var bsCollapse = new Collapse(myCollapse, {
        toggle: false
    })

    var raterList = {};
    const teamId = document.getElementById("team-id");
    const projName = document.getElementById("project-name");
    const caseStudy = document.getElementById("case-study");
    const tagline = document.getElementById("oneLiner");
    const youtube = document.getElementById("youtube-embed");
    const youtubeURL = document.getElementById("youtube-url");
    const figma = document.getElementById("figma-embed");
    const figmaURL = document.getElementById("figma-url");
    const desc = document.getElementById("description");

    const judgeComments = document.getElementById("judge-cmt");

    var unsub = onAuthStateChanged(auth, (user) => {
        unsub();

        if (!user) {
            setUserAlert(`You are not logged in! Login <a href="/signin.html">here</a>.`, true);
        } else {
            judgeUID = user.uid;
            if (!user.emailVerified) {
                setUserAlert(`Please verify your email before proceeding. You may have the verification email resent to you by <a href="/judge/signin.html">signing in again</a>. Thank you.`, true);
                return;
            }

            getDoc(doc(db, "judges", judgeUID)).then(data => {
                if (!data.exists()) {
                    setUserAlert(`You are not authorized to use this portal. Please contact us via email if you believe this is not the case.`);
                    return;
                }
                judgeData = data.data();

                // Load judge info
                document.querySelector("#fname").innerHTML = judgeData.name;
                document.querySelector("#uemail").innerHTML = user.email;
                document.querySelector("#company").innerHTML = judgeData.company;
                document.querySelector("#judgetype").innerHTML = judgeData.judge_type;

                // Stars
                const techJudgingCat = ["Feasibility of Concept", "Innovativeness", "Design", "Pitch"];
                const busJudgingCat = ["Market Segment", "Business Model", "Design", "Pitch"];
                const bothJudgingCat = ["Feasibility of Concept", "Innovativeness", "Market Segment", "Business Model", "Design", "Pitch"];
                var judgingCat;

                document.getElementById("download-rubric").classList.remove("d-none");
                document.getElementById("reset-password").classList.remove("d-none");
                
                if (judgeData.judge_type === "Technical") {
                    judgingCat = techJudgingCat;
                    document.getElementById("technical-rubric").classList.remove("d-none");
                    document.getElementById("download-rubric").href = "https://data.vhackusm.com/docs/technical-rubric.pdf";
                } else if (judgeData.judge_type === "Business") {
                    judgingCat = busJudgingCat;
                    document.getElementById("business-rubric").classList.remove("d-none");
                    document.getElementById("download-rubric").href = "https://data.vhackusm.com/docs/business-rubric.pdf";
                } else if (judgeData.judge_type === "Admin" || judgeData.judge_type === "Company") {
                    judgingCat = [];
                    document.getElementById("judging-eval").classList.add("d-none");
                } else if (judgeData.judge_type === "Technical & Business") {
                    judgingCat = bothJudgingCat;
                    document.getElementById("technical-rubric").classList.remove("d-none");
                    document.getElementById("business-rubric").classList.remove("d-none");
                    document.getElementById("download-rubric").classList.add("d-none");
                }

                judgingCat.forEach(cat => {
                    let lowerCat = cat.toLowerCase().replaceAll(" ", "-");
                    document.getElementById("judge-ratings").innerHTML += `
                    <div class="col-12 col-md-6">
                        <p class="mb-0">${cat}</p>
                        <div class="d-flex align-items-center flex-wrap">
                            <div class="rater" id="${lowerCat}"></div>
                            <span id="${lowerCat}-counter" class="mt-sm-0 mt-1 ms-3">/10</span>
                        </div>
                    </div>`;
                });

                document.querySelectorAll(".rater").forEach(ele => {
                    var myRater = raterFunction({element: ele, max: 10, starSize: 24, rateCallback: (rating, done) => {
                        let elementID = ele.id;

                        if (rating <= 0) {
                            rating = 1;
                            myRater.setRating(rating);
                        }
                        document.getElementById(elementID+"-counter").textContent = rating+"/10";
                        myRater.setRating(rating);
                        done();
                    }});
                    raterList[ele.id] = myRater;
                });

                // Assigned team
                assignedTeamUID = judgeData.assigned_team;

                if (!assignedTeamUID) {
                    document.getElementById("team-eval-loading").innerHTML = `<div class="alert alert-warning" role="alert">No teams are assigned yet! Sorry for the delay, please check back on around <b>28<sup>th</sup> March 2022</b> 10.00PM (GMT+8)</div>`;
                    setAvatar(judgeData.name);
                    return;
                }

                var currNum = 0;

                assignedTeamUID.forEach(teamUID => {
                    let bypass = false;
                    // if (/\?bypass=true/.test(window.location.href)) bypass = true;
                    // console.log(judgeData.bypass.includes(teamUID));
                    if (judgeData.bypass && judgeData.bypass.includes(teamUID)) bypass = true;

                    getCacheTeamData(teamUID, bypass).then(data => {
                        assignedTeamDataList.push(data);

                        let evaluated = false;
                        if (judgeData.evaluated && judgeData.evaluated.includes(data.team_no)) {
                            evaluated = true;
                        }

                        document.getElementById("team-evaluation").innerHTML += 
                            returnProjectList(data.team_no, data.project_name, data.tagline, evaluated);

                        // Last object
                        if (currNum == assignedTeamUID.length - 1) {
                            document.getElementById("team-eval-loading").classList.add("d-none");
                            collapseShow("team-evaluation");
                            assignedTeamDataList.forEach(data => {
                                
                                // Button for judging
                                document.getElementById(`${data.team_no}-eval`).addEventListener("click", () => {
                                    bsCollapse.show();
                                    currentTeamNo = data.team_no;
                                    currentTeamUID = teamUID;
                                    currentEvalData = getJudgeEval();

                                    // Project details
                                    projName.textContent = data.project_name;
                                    teamId.textContent = `(Team ${data.team_no})`;
                                    
                                    switch(data.case_study) {
                                        case 1: 
                                            caseStudy.textContent = "Environmental: Recent Flash Floods";
                                            break;
                                        case 2: 
                                            caseStudy.textContent = "Social: Youth Suicide";
                                            break;
                                        case 3: 
                                            caseStudy.textContent = "Education: Online Learning";
                                            break;
                                        case 4: 
                                            caseStudy.textContent = "Poverty: White Flag Movement";
                                            break;
                                        case 5: 
                                            caseStudy.textContent = "Economics: Food Security";
                                            break;
                                        default:
                                            caseStudy.textContent = "Unknown";
                                            break;
                                    }
                
                                    tagline.textContent = data.tagline;
                                    youtube.src = `https://www.youtube-nocookie.com/embed/${data.yt_id}`;
                                    youtubeURL.href = data.yt_url;
                                    youtubeURL.textContent = data.yt_url;
                                    figma.src = `https://www.figma.com/embed?embed_host=vhackusm&url=${data.figma_url}`;
                                    figmaURL.textContent = data.figma_url;
                                    figmaURL.href = data.figma_url;
                                    desc.innerHTML = xss(marked.parse(data.description));
                
                                    var collapseButton = document.getElementById("collapseButton");
                                    if (collapseButton.ariaExpanded === "false") {
                                        collapseButton.click();
                                    }

                                    // Check for current evaluation
                                    getDoc(doc(db, "judges", judgeUID, "draft", currentTeamNo)).then(evalData => {
                                        if (evalData.exists()) {
                                            const eData = evalData.data();
                                            
                                            for (const key in raterList) {
                                                if (eData[key]) {
                                                    raterList[key].setRating(eData[key]);
                                                    document.getElementById(key+"-counter").textContent = eData[key]+"/10";
                                                } else {
                                                    raterList[key].clear();
                                                    document.getElementById(key+"-counter").textContent = "/10";
                                                }
                                            }
                                            judgeComments.value = eData["comments"] ? eData["comments"] : "";
                                            judgeComments.dispatchEvent(new KeyboardEvent('keydown'));
                                            if (eData.last_submitted) {
                                                setLastSubmitted(eData.last_submitted.seconds*1000);
                                            } else {
                                                resetLastSubmitted();
                                            }
                                        } else {
                                            for (const key in raterList) {
                                                raterList[key].clear();
                                                document.getElementById(key+"-counter").textContent = "/10";
                                            }
                                            judgeComments.value = "";
                                            judgeComments.dispatchEvent(new KeyboardEvent('keydown'));
                                            resetLastSubmitted();
                                        }
                                    }).catch(err => {
                                        errorAlert(`EVAL1 ${teamUID}`, err)
                                    });
                                    
                                    setTimeout(() => document.querySelector("#card-eval").scrollIntoView(), 100);
                                });
                            });
                        }
                        currNum += 1;
                    }).catch(err => {
                        errorAlert("FE1", err);
                    });
                });

                setAvatar(judgeData.name);


            }).catch(err => {
                if (err.code === "permission-denied") {
                    setUserAlert(`You may not be authorized to use this portal. Please contact us via email if you believe this is not the case.`);
                }
                errorAlert("AUTH0", err);
            });

        }
    });

    document.querySelector("#signout").addEventListener("click", () => {
        document.querySelector("#signout").innerHTML = `<div class="spinner-border text-light spinner-border-sm ms-1" role="status"><span class="visually-hidden">Loading...</span></div>`;
        signOut(auth).then(() => {
            window.location.href = "/index.html";
        }).catch((err) => {
            setUserAlert(err.message,false);
        });
    });


    // Save
    document.getElementById("save-btn").addEventListener("click", () => {
        const loading = setSpinner("save-btn", "primary");
        document.getElementById("save-btn").disabled = true;

        var obj = getJudgeEval();
        if (JSON.stringify(obj) === JSON.stringify(currentEvalData)) {
            alert("You are submitting the same information!");
            loading(true);
            return;
        }
        currentEvalData = obj;

        setDoc(doc(db, "judges", judgeUID, "draft", currentTeamNo), currentEvalData, {merge: true}).then(() => {
            logSubmission(currentEvalData, false);
            successBadge();
            loading(true);
        }).catch(err => {
            if (err.code === "permission-denied" && Date.now() > cutoffTime) {
                setUserAlert(`The evaluation could not be saved. It may be because the cut-off time had been reached. Contact us if you believe this is incorrect.`);
            } else {
                errorAlert("SAVE", err);
            }
            loading(true);
        });

    });

    // Submit
    document.getElementById("submit-btn").addEventListener("click", () => {
        const loading = setSpinner("submit-btn", "primary");
        document.getElementById("submit-btn").disabled = true;

        currentEvalData = getJudgeEval(true);
        currentEvalData.last_submitted = new Date();

        for (const key in currentEvalData) {
            if (currentEvalData.hasOwnProperty(key)) {
                if (!currentEvalData[key]) {
                    loading(true);
                    alert(`${capitalizeFirstLetter(key)} cannot be blank!`);
                    return;
                }
                if (key === "comments" && currentEvalData[key].split(' ').length < 50) {
                    loading(true);
                    alert("Please fill in at least 50 words for your comments.");
                    return;
                }
            }
        }

        const batch = writeBatch(db);        

        batch.set(doc(db, "judges", judgeUID, "draft", currentTeamNo), currentEvalData);
        batch.set(doc(db, "submission", currentTeamUID, "evaluation", judgeUID), currentEvalData);
        if (!judgeData.evaluated || !judgeData.evaluated.includes(currentTeamNo)) {
            batch.set(doc(db, "judges", judgeUID), {evaluated: arrayUnion(currentTeamNo) }, { merge: true })
        }

        batch.commit().then(() => {
            setLastSubmitted(new Date());

            logSubmission(currentEvalData, true);
            document.getElementById(`${currentTeamNo}-list`).classList.add("list-group-item-success");
            successBadge();
            loading(true);
        }).catch(err => {
            if (err.code === "permission-denied" && Date.now() > cutoffTime) {
                setUserAlert(`The evaluation could not be submitted. It may be because the cut-off time had been reached. Contact us if you believe this is incorrect.`);
            } else {
                errorAlert("SUBMIT", err);
            }
            loading(true);
        });
    });

    // Log submission
    function logSubmission(obj, isSubmit = false) {
        var logObject = { ...obj };
        logObject.isSubmit = isSubmit;
        logObject.judge_uuid = judgeUID;
        logObject.judge_name = judgeData.name;
        logObject.judge_email = judgeData.email;
        logObject.judge_type = judgeData.judge_type;
        logObject.judge_company = judgeData.company;

        logObject.team_no = currentTeamNo;

        fetch(`https://vhackusm.com/api/new-submission`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(logObject)
        }).catch(err => console.log(err));
    }

    // Reset password
    document.getElementById("reset-password").addEventListener("click", () => {
        if (confirm("A reset password email will be sent to you. Proceed?")) {
            const loading = setSpinner("reset-password", "primary");
            document.getElementById("reset-password").disabled = true;
            sendPasswordResetEmail(auth, judgeData.email)
            .then(() => {
                alert(`A reset password email is sent to ${judgeData.email}.`);
                loading(true);
            })
            .catch((err) => {
                errorAlert("RESET", err);
                loading(true);
            });
        }
    });

    function getJudgeEval(includeNull = true) {
        var obj = {};
        
        for (const key in raterList) {
            if (raterList[key].getRating() || includeNull) obj[key] = raterList[key].getRating();
        }
        obj["comments"] = document.getElementById("judge-cmt").value;
        return obj;
    }

    function setUserAlert(str = "", scrollToTop = true) {
        let userAlert = document.querySelector("#judge-alert");
        if (str !== "") userAlert.innerHTML = `<div class="alert alert-warning" role="alert">${str}</div>`;
        else userAlert.innerHTML = "";;
        if (str !== "" && scrollToTop) {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }
    }

    function errorAlert(errCode, err) {
        setUserAlert(`Something went wrong, please reload and try again. You may contact judge@vhackusm.com with your account info and the following message: 
                    <span class="text-muted small">${errCode}: ${err.message} ${judgeUID}</span>`);
    }

    function setAvatar(name = "") {
        document.querySelector("#avatar").innerHTML = `<i class='bx bxs-user-circle d-none d-sm-block' style="font-size: 2rem;"></i>`;
        document.querySelector("#account-name").innerHTML = name;
    }

    function setSpinner(tag, col = "text-light") {
        const ele = document.getElementById(tag);
        const inner = ele.innerHTML;
        ele.innerHTML = `<div class="spinner-border ${col} spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>`;
        return function(btnEnable) {
            ele.innerHTML = inner;
            if (btnEnable) ele.disabled = false;
        };
    }

    const checkmark = document.getElementById('checkmark');
    var cmCollapse = new Collapse(checkmark, {
        toggle: false
    })
    cmCollapse.hide();

    function successBadge() {
        cmCollapse.show();
        setTimeout(() => {
            cmCollapse.hide();
        }, 3000);
    }

    function returnProjectList(teamNo, teamName, teamTagline, evaluated) {
        let indicator = "";
        if (evaluated) indicator = "list-group-item-success";

        return `<li class="list-group-item ${indicator} d-flex justify-content-between align-items-center gap-3 py-3" id="${teamNo}-list">
        <div><span class="project-name h6">${teamNo}. ${teamName}</span><br/><p class="one-liner text-muted mx-3 mt-1 mb-0">${teamTagline}</p></div>
            <button class="btn btn-sm btn-primary" title="Show Project" id="${teamNo}-eval"><i class='bx bxs-message-check text-white fs-5 align-middle'></i></button></li>`
    }

    async function getCacheTeamData(id, bypass = false) {
        const docRef = doc(db, "submission", id);
        let docs;
        try {
            if (bypass) docs = await getDoc(docRef);
            else docs = await getDocFromCache(docRef);
        } catch (e) {
            docs = await getDoc(docRef);
        }
        return docs.data();
    }

    function setLastSubmitted(ts) {
        clearInterval(currInterval);
        currInterval = timeTrack(new Date(ts), document.getElementById("last-submit"));
        const badge = document.getElementById("last-submit-badge");
        if (badge.classList.contains("bg-danger")) {
            badge.classList.remove("bg-danger");
            badge.classList.add("bg-success");
        }        
    }

    function resetLastSubmitted() {
        clearInterval(currInterval);
        document.getElementById("last-submit").textContent = "None";
        const badge = document.getElementById("last-submit-badge");
        if (badge.classList.contains("bg-success")) {
            badge.classList.remove("bg-success");
            badge.classList.add("bg-danger");
        }        
    }

    function setAvatar(name = "") {
        document.querySelector("#avatar").innerHTML = `<i class='bx bxs-user-circle d-none d-sm-block' style="font-size: 2rem;"></i>`;
        document.querySelector("#account-name").innerHTML = name;
    }

    function collapseShow(id) {
        return new Collapse(document.getElementById(id), {
            toggle: false
        }).show();
    }
});



function timeSince(date) {
    var seconds = Math.floor((new Date() - date) / 1000);
    var interval = seconds / 31536000;
    if (seconds < 0) {
      return "N/A";
    }
    if (interval > 1) {
      return Math.floor(interval) + " years";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes";
    }
    return Math.floor(seconds) + " seconds";
}

function timeTrack(date, ele) {
    var timeTrackStr = timeSince(date);
    ele.textContent = timeTrackStr + " ago";

    if (timeTrackStr.includes("second")) {
        return timeTrackSub(date, ele, "minutes", 1, () => timeTrack(data, ele));
    } else if (timeTrackStr.includes("minutes")) {
        return timeTrackSub(date, ele, "hours", 10, () => timeTrack(data, ele));
    } else if (timeTrackStr.includes("hours")) {
        return timeTrackSub(date, ele, "days", 60, () => timeTrack(data, ele));
    }
}

function timeTrackSub(date, ele, text, dt, callback) {
    return setInterval(() => {
        var timeTrackStr = timeSince(date);
        ele.textContent = timeTrackStr + " ago";
        if (timeTrackStr.includes(text)) {
            clearInterval(interval);
            callback();
        }
    }, dt*1000);
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
